import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { useAppDispatch, useAppSelector } from '@/shared/store/hooks';
import { setIntendedPath } from '@/shared/store/slices/authIntendedDestinationSlice';
import { selectUser } from '@/shared/store/slices/authSlice';
import { AppBootstrapLoader } from '@/components/app/AppBootstrapLoader';

type Props = { children: ReactNode };

export function RequireAuth({ children }: Props) {
  const auth = useAuth();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const reduxUser = useAppSelector(selectUser);

  if (auth.isLoading) {
    return <AppBootstrapLoader />;
  }

  const isAuthenticated = auth.isAuthenticated || reduxUser !== null;

  if (!isAuthenticated) {
    dispatch(setIntendedPath(location.pathname));
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
}
